import React from 'react';
import { map, isEmpty, size, head, get, last } from 'lodash';
import moment from 'moment';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { offCallDispositionActivity as OffCallDispositionActivity } from 'ui/views/widgets/offCallDispositionActivity';
 *
 * // render
 * <OffCallDispositionActivity propName='propValue'/>
 */
export const offCallDispositionActivitySuccess = ( props ) => {

    // dashed line class name
    const dashbedLineClassName = classnames( 'ui-off-call-disposition-activity__items-pane__dashed-line', {
        'ui-off-call-disposition-activity__items-pane__dashed-line--hidden': 2 > size( props.items ), // hide it when `items` are less than 2
        [ `ui-off-call-disposition-activity__items-pane__dashed-line--top-offset-${ size( get( head( props.items ), 'values' ) ) }` ]: ! isEmpty( get( head( props.items ), 'values' ) ), // large offset from `top` if `subtitle` of the `first` item is present
        [ `ui-off-call-disposition-activity__items-pane__dashed-line--bottom-offset-${ size( get( last( props.items ), 'values' ) ) }` ]: ! isEmpty( get( last( props.items ), 'values' ) ), // large offset from `bottom` if `subtitle` of the `last` item is present
    } );
    
    return (
        <div className='ui-off-call-disposition-activity'>
            <div className='ui-off-call-disposition-activity__items-pane'>

            <div className='ui-call-widget-activity__items-pane__group'>

                {/* dashed line */}
                <div className={ dashbedLineClassName }/>

                {/* items */}
                <div className='ui-off-call-disposition-activity__items-pane__items'>
                    {
                        map( props.items, item => {

                            // dynamic item class name
                            const itemClassName = classnames( 'ui-off-call-disposition-activity__items-pane__items__item', {
                                [ `ui-call-disposition-activity__items-pane__items__item--height-${ size( item.values ) }` ]: ! isEmpty( item.values ),
                            } );

                            return (
                                <div key={ item.id } className={ itemClassName }>

                                    {/* values */}
                                    {
                                        map( item.values, ( _value, _index ) => {
                                            return (
                                                <p key={ _index } className='ui-off-call-disposition-activity__items-pane__items__item__title'>{ _value }</p>
                                            );
                                        } )
                                    }

                                    {/* timestamp */}
                                    <p className='ui-off-call-disposition-activity__items-pane__items__item__timestamp'>{ moment( item.timestamp ).format( 'MM-DD-YYYY hh:mm:ss A' ) }</p>
                                </div>
                            );
                        } )
                    }
                    </div>
                </div>
            </div>
        </div>
    );
};

// set display name
offCallDispositionActivitySuccess.displayName = 'offCallDispositionActivitySuccess';

// set default props
offCallDispositionActivitySuccess.defaultProps = {};

// prop types
offCallDispositionActivitySuccess.propTypes = {};

/*******************************/

// preloader view
export const offCallDispositionActivityPreloader = () => {
    return (
        <div className='ui-off-call-disposition-activity-preloader'>
            {
                    map( [ 1, 2 ], item => {
                        return (
                            <div key={ item } className='ui-off-call-disposition-activity-preloader__item'>
                                <div className='ui-off-call-disposition-activity-preloader__item__title' />
                                <div className='ui-off-call-disposition-activity-preloader__item__subtitle' />
                            </div>
                        );
                    } )
                }
        </div>
    );
};

// set display name
offCallDispositionActivityPreloader.displayName = 'offCallDispositionActivityPreloader';

// set default props
offCallDispositionActivityPreloader.defaultProps = {};

// prop types
offCallDispositionActivityPreloader.propTypes = {};


/*******************************/


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callDispositionActivity as CallDispositionActivity } from 'ui/views/widgets/callDispositionActivity';
 *
 * // render
 * <CallDispositionActivity propName='propValue'/>
 */
export const offCallDispositionActivity = withNetworkState( offCallDispositionActivityPreloader, offCallDispositionActivitySuccess );
